import script from './ItineraryWaypointActionCard.vue2.js';
import normalizeComponent from '../../../../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';
import createInjector from '../../../../../../../node_modules/vue-runtime-helpers/dist/inject-style/browser.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "BasicCard",
    { staticClass: "ItineraryWaypointActionCard" },
    [
      _c("ItineraryNonMailInWaypointActionCard", {
        attrs: {
          waypointAction: _vm.waypointAction,
          inputDisabled: _vm.inputDisabled || _vm.viewAs.nurse
        }
      }),
      _vm._v(" "),
      _vm.workflowContexts && _vm.workflows && !_vm.hideWorkflow
        ? _c(
            "span",
            _vm._l(_vm.workflowContexts, function(context) {
              return _c("span", { key: context }, [
                _vm.workflows[context]
                  ? _c(
                      "span",
                      [
                        _c("InlineWorkflow", {
                          key:
                            "workflow-" +
                            _vm.waypointAction.id +
                            "-" +
                            context.toString(),
                          attrs: {
                            id: _vm.waypointAction.id,
                            disabled: !_vm.isActionable,
                            workflow: _vm.workflows[context],
                            parentID: _vm.waypointAction.waypointID,
                            storeRef: "waypointActions",
                            context: context
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4c4b0064_0", { source: "/** I feel like we need to improve the naming convention here */\n.background-green-25 {\n  background-color: #F6FEF9;\n}\n.background-purple-50 {\n  background-color: #F9F5FF;\n}\n.background-blue-25 {\n  background-color: #F5F8FF;\n}\n.background-red-25 {\n  background-color: #FFFBFA;\n}\n.background-orange-50 {\n  background-color: #FFFAEB;\n}\n\n/** --------------------------- BRAND VARIABLES ---------------------------- **/\n/** ---------------------------- COLOR PALETTE ----------------------------- **/\n/** ------------------------- TEXT & ICON PALETTE -------------------------- **/\n/** ---------------------------- LINK PALETTE ------------------------------ **/\n/** --------------------------- BUTTON PALETTE ----------------------------- **/\n/** --------------------------- INPUT STYLES ----------------------------- **/\n/** ---------------------------- MAP STYLES ----------------------------- **/\n/** ---------------------------- TOAST STYLES ----------------------------- **/\n/* Bulma Utilities */\n/** dash-size (1: solid, 2: 2 on/2 off, 3: 8 on/8 off, 4: 16 on/16 off) */\n/**\n * * Dashed-border does not behave nicely with real borders, if using, do not\n * * use border.\n * */\n\n/*# sourceMappingURL=ItineraryWaypointActionCard.vue.map */", map: {"version":3,"sources":["ItineraryWaypointActionCard.vue"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,6EAA6E;AAC7E,4EAA4E;AAC5E,8EAA8E;AAC9E,oBAAoB;AACpB,yEAAyE;AACzE;;;IAGI;;AAEJ,0DAA0D","file":"ItineraryWaypointActionCard.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__ as default };
